import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { RequestsPage } from '@/features/resources/requests-page';

const searchSchema = z.object({ request: z.string().optional().catch(undefined) });

export const Route = createFileRoute('/_app/projects/$projectId/resources/requests')({
  validateSearch: searchSchema,
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  const search = Route.useSearch();
  return <RequestsPage projectId={projectId} requestId={search.request} />;
}
